import React, { useContext, useEffect, useState } from "react";
import yourLogo from "../../assets/images/logo-black.png";
import teleCall from "../../assets/images/icons/telephone.svg";
import insiderImg from "../../assets/images/icons/landingicon.svg";
import mailBox from "../../assets/images/icons/emailSvg.svg";
import passBox from "../../assets/images/icons/lock.svg";
import login_img from "../../assets/images/bg1.jpg";
import eye from "../../assets/images/icons/eye.svg";
import eyeHide from "../../assets/images/icons/hidePassword.svg";
import facebook from "../../assets/images/icons/Facebook.svg";
import apple from "../../assets/images/icons/apple.svg";
import google from "../../assets/images/icons/google.svg";
import doodleRed from "../../assets/images/icons/doodle-red.svg";
import doodleSmall from "../../assets/images/icons/doodle-small.svg";
import doodle from "../../assets/images/icons/doodle-5 2.svg";
import { Link, useNavigate } from "react-router-dom";
import ApiConfig from "../../api/ApiConfig"; // your API endpoints
import {
  PostCallWithErrorResponse,
  PostCallWithErrorResponseLoggin,
  simpleGetCallWithErrorResponse,
  simpleGetCallWithErrorResponseWIFI,
  simplePostCall,
} from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";

const Login = () => {
  const [emailPhone, setEmailPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);
  const [country, setCountry] = useState({ callingCode: ["91"] });
  const navigate = useNavigate();
  const { socket,loginType, setLoginType } = useContext(AppContext);

  const [profileData, setProfileData] = useState([]);
 
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const handleSendOtp = () => {
    setIsLoadingOTP(true);
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const regex = /^\d{10}$/;
    let checkIsEmail = emailPattern.test(emailPhone);

    if (checkIsEmail) {
      notifyError("Email login coming soon. Please try with phone number.");
      setIsLoadingOTP(false);
      return;
    }

    if (!regex.test(emailPhone)) {
      notifyError("Invalid phone number or email address");
      setIsLoadingOTP(false);
      return;
    }

    const body = {
      phoneNumber: "+" + country.callingCode[0] + emailPhone,
      Hash: "fygKr7uOg",
    };

    PostCallWithErrorResponseLoggin(ApiConfig.SEND_OTP, JSON.stringify(body))
      .then((res) => {
        setIsLoadingOTP(false);
        if (res?.json.success === true) {
          notifySuccess(res?.json?.message);
        } else {
          notifyError(res?.json?.message || "Failed to send OTP");
        }
        console.log("SEND_OTP Response:", res);
      })
      .catch((err) => {
        setIsLoadingOTP(false);
        console.error("SEND_OTP Error:", err);
        notifyError(err?.json?.message);
      });
  };

  // 2️⃣ Verify OTP and Login
  const handleLoginZamzam = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let checkIsEmail = emailPattern.test(emailPhone);

    if (otp.length < 4) {
      notifyError("Invalid OTP!");
      return;
    }

    const body = {
      phoneNumber: checkIsEmail
        ? emailPhone
        : "+" + country.callingCode[0] + emailPhone,
      otp: otp,
      platform: "web",
    };

    setIsLoading(true);
    PostCallWithErrorResponseLoggin(
      ApiConfig.LOGIN_WITH_OTP,
      JSON.stringify(body)
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.json.success === true) {
          localStorage.setItem("LOGIN_DATA", JSON.stringify(res.json.data));
          localStorage.setItem("Token", JSON.stringify(res.json.token));
     
          // ToastMsg("success", "Login Successful!");

          navigate("/Home");
        } else {
          notifyError(res?.json?.message || "Invalid OTP");
        }
        console.log("LOGIN Response:", res.json);
      })
      .catch((err) => {
        setIsLoading(false);
        notifyError("Something went wrong. Pleas try again later.");
        console.error("LOGIN Error:", err);
        // ToastMsg("error", err?.message);
      });
  };

 const LogInWifi = async (e) => {
  e.preventDefault();



  const body = {
    Username,
    Password,
  };

  setIsLoading(true);

  PostCallWithErrorResponse(ApiConfig.WIFI_LOGIN, JSON.stringify(body))
    .then(async (res) => {
      setIsLoading(false);

      console.log("Agent Login Response:", res);

      if (res.json && res.json?.Success === true) {
        
        // ✅ Save login data just like Zamzam
       

        // If backend sends token, store it; else ignore
       loadProfileDetails(res.json.Data.Token)
          // localStorage.setItem("Token", JSON.stringify(res.json.Data.Token));
        

        notifySuccess("Agent Login Successful!");

        navigate("/Home");

      } else {
        notifyError(res?.json?.Message || "Invalid credentials");
      }
    })
    .catch((err) => {
      setIsLoading(false);
      notifyError("Login Failed!");
    });
};
const loadProfileDetails = async (Token) => {
  try {
    let res = await simpleGetCallWithErrorResponseWIFI(
      `${ApiConfig.GET_PROFILE}`,
      Token
    );

    console.log("PROFILE API RESPONSE:", res);

    if (res?.json?.success) {
      // store data
      localStorage.setItem("LOGIN_DATA", JSON.stringify(res.json.data));
      localStorage.setItem("Token", JSON.stringify(res.json.token));

      // Socket Emit Check
      const singleVehicleData = {
        user_id: res.json.data.id,
      };

      console.log("EMITTING: singleVehicle", singleVehicleData);
      socket?.emit("singleVehicle", singleVehicleData, (ack) => {
        console.log("ACK from Server (singleVehicle):", ack);
      });

      console.log("EMITTING: push notification", singleVehicleData);
      socket?.emit("push notification", singleVehicleData, (ack) => {
        console.log("ACK from Server (push notification):", ack);
      });
    }
  } catch (e) {
    console.error("Profile Load Error:", e);
  }
};



    useEffect(() => {
      const userAgent = navigator.userAgent.toLowerCase();
  
      if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        // iOS device → redirect to App Store
        window.location.href =
          "https://apps.apple.com/in/app/my-zamzam-app/id6752317913";
      } 
      else if (userAgent.includes("android")) {
        // Android device → redirect to Play Store
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.zamzam.restaurantapp";
      } 
      else {
        // Desktop → stay on website
        console.log("User using web browser");
      }
    }, []);

  return (
    <>
      <div className="authMain loginMain">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-5">
              <div
                className="signinForm p-3 p-md-4"
                style={{ width: "100%", margin: "auto" }}
              >
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* Logo */}
                  <div className="d-flex justify-content-center mb-4">
                    <img
                      src={yourLogo}
                      alt="logo"
                      style={{ height: "160px", maxWidth: "100%" }}
                    />
                  </div>

                  {/* Phone Number */}
                  {loginType === "agent" && (
                    <>
                      <div className="inputBox mt-3">
                        <label className="emailLabel">Email</label>
                        <input
                          type="text"
                          className="form-control formInput"
                          placeholder="Enter email"
                          value={Username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>

                      <div className="inputBox mt-3">
                        <label className="emailLabel">Password</label>
                        <input
                          type="password"
                          className="form-control formInput"
                          placeholder="Enter password"
                          value={Password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </>
                  )}

                  {/* ----------------- ZAMZAM LOGIN FIELDS ----------------- */}
                  {loginType === "zamzam" && (
                    <>
                      <div className="inputBox mt-3">
                        <label className="emailLabel">Phone Number</label>
                        <input
                          type="number"
                          className="form-control formInput no-spinner"
                          placeholder="Enter phone number"
                          value={emailPhone}
                          onChange={(e) => setEmailPhone(e.target.value)}

                          onWheel={(e) => e.target.blur()}        // disable mouse scroll
  onKeyDown={(e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();                 // disable arrow keys
    }
  }}
                        />
                      </div>

                      <div className="inputBox mt-3">
                        <label className="emailLabel">OTP</label>
                        <input
                          type="number"
                          className="form-control formInput no-spinner"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          onWheel={(e) => e.target.blur()}        // disable mouse scroll
  onKeyDown={(e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();                 // disable arrow keys
    }
  }}
                        />
                      </div>
                    </>
                  )}

                  {/* Buttons */}
                  <div
                    className="login d-flex flex-column align-items-center mt-4"
                    style={{ width: "100%" }}
                  >
                    {/* Row on desktop / stacked on mobile */}
                    <div className="d-flex flex-column flex-md-row justify-content-center gap-3 w-100 mb-3">
                       {loginType === "zamzam" && (
                      <>
                      {/* Send OTP */}
                      <Link
                        to="#"
                        className="d-flex justify-content-center loginBtn"
                        style={{ textDecoration: "none",  }}
                      >
                        <button
                          type="button"
                          className="btn-custom"
                          onClick={handleSendOtp}
                          disabled={isLoadingOTP}
                          style={{ textDecoration: "none",  }}
                        >
                          {isLoadingOTP ? "loading..." : "Send OTP"}
                        </button>
                      </Link>
                       </>
                      )}
                      {/* Login */}
        
                        <>
                          <Link
                            to="#"
                            className=" d-flex justify-content-center loginBtn"
                            style={{ textDecoration: "none", }}
                          >
                            <button
                
                              type="button"
                              className="btn-custom"
                              onClick={
                                loginType === "agent"
                                  ? LogInWifi
                                  : handleLoginZamzam
                                 
                              }
                            >
                              {isLoading ? "Logging in..." : "Login"}
                            </button>
                          </Link>
                        </>
                   
                    </div>
                    {loginType === "zamzam" && (
                      <>
                        <Link
                          to="/Registration"
                          className=" d-flex justify-content-center loginBtn"
                          style={{ textDecoration: "none",}}
                        >
                          {/* Registration */}

                          <button type="button" className="btn-custom" 
         
                          >
                            Registration
                          </button>
                        </Link>
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
